import { put, takeEvery, all, call, select, spawn } from "redux-saga/effects";
import { SET_UP, COMPLETE_TOUR, EXECUTE_ACTION, DATA_LOADED, ACHIEVE, OPEN_ACHIEVEMENT_BANNER, CLOSE_ACHIEVEMENT_BANNER,  } from "../store";

const delay = ms => new Promise(res => setTimeout(res, ms));

function* setUp({ payload: { loadData } }) {
  const { actionsExecuted, toursCompleted, achievements, achievementsAvailable} = yield call(loadData);
  yield put({ type: DATA_LOADED, payload: { toursCompleted, actionsExecuted, achievements, achievementsAvailable } });
}

function* completeTour({ payload: tourId }) {
  const completeTour = yield select(state => state.onboarding._completeTour);
  yield call(completeTour, tourId);
}

function* saveAchievement({ payload: achievementId }) {
  const { _saveAchievement: saveAchievement, achievementsAvailable } = yield select(state => state.onboarding);
  const achievement = achievementsAvailable.find(a => a.achievementId === achievementId);
  yield call(saveAchievement, {
    achievementId: achievement.achievementId,
    title: achievement.title,
    description: achievement.description,
  });
}

function* executeAction({ payload: actionId }) {
  const executeAction = yield select(state => state.onboarding._executeAction);
  yield all([call(executeAction, actionId), call(achieve)]);
}

function* showAchievementBanner(achievementId) {
  const { achievementsAvailable } = yield select(state => state.onboarding);
  const achievement = achievementsAvailable.find(a => a.achievementId === achievementId);
  yield put({ type: OPEN_ACHIEVEMENT_BANNER, payload: achievement });
  yield call(delay, 8000);
  yield put({ type: CLOSE_ACHIEVEMENT_BANNER });
}

function* achieve() {
  const { toursCompleted, actionsExecuted, achievements, achievementsAvailable } = yield select(state => state.onboarding);
  const achievementsCompleted = achievementsAvailable
    .filter(achievement => !achievements.find(a => a.achievementId === achievement.achievementId))
    .filter(achievement => achievement.condition(actionsExecuted, toursCompleted))
    .map(achievement => achievement.achievementId);
  for (let id of achievementsCompleted) {
    yield put({ type: ACHIEVE, payload: id });
    yield spawn(showAchievementBanner, id);
  }
}

function* watchSetUp() {
  yield takeEvery(SET_UP, setUp);
}

function* watchCompleteTour() {
  yield takeEvery(COMPLETE_TOUR, completeTour);
}

function* watchExecuteAction() {
  yield takeEvery(EXECUTE_ACTION, executeAction);
}

function* watchAchieve() {
  yield takeEvery(ACHIEVE, saveAchievement);
}

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export function* rootSaga() {
  yield all([watchSetUp(), watchCompleteTour(), watchExecuteAction(), watchAchieve()]);
}
